/**
 * Dependencies.
 */
import { createElement as el } from "@wordpress/element";
import TabLayout from "../TabLayout/TabLayout";
import Tabs from "../Tabs/Tabs";

interface PanelBodyProps {
  open: boolean;
  onMouseLeave?: Function;
  className?: string;
}

/**
 * Provides a Panel Body.
 *
 * @return {element} PanelBody.
 */
const PanelBody = (props: PanelBodyProps) => {
  const { open, onMouseLeave } = props;
  const panelBodyClass = "components-panel__body wpglobus-switcher-panel__body";
  return el(
    "div",
    {
      className: panelBodyClass + (open ? " is-opened" : " hidden"),
      onMouseLeave: onMouseLeave,
    },
    <TabLayout Tabs={Tabs} initialTabName={"switcher"} />
  );
};

export default PanelBody;
